import React, { useState, useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArchive, faCalendarAlt } from '@fortawesome/free-solid-svg-icons';

const ArchiveGroupsTabs = ({ 
  periods, 
  groupsData, 
  onCloseArchive,
  onChange,
  children,
  isEmpty
}) => {
  const [activePeriod, setActivePeriod] = useState(periods[0]?.value || '');
  const [selectedGroup, setSelectedGroup] = useState(null);

  // Форматируем период для отображения (2024 -> 2024-2025)
  const formatPeriodDisplay = (period) => {
    if (period.includes('-')) return period;
    const year = parseInt(period);
    return `${year}-${year + 1}`;
  };

  // Получаем группы для выбранного периода
  const groupsForPeriod = useMemo(() => {
    if (!activePeriod) return [];
    return groupsData.filter(group => group.period === activePeriod);
  }, [activePeriod, groupsData]);

  // Сортируем периоды в обратном порядке (новые сначала)
  const sortedPeriods = useMemo(() => {
    return [...periods].sort((a, b) => {
      const yearA = parseInt(a.value);
      const yearB = parseInt(b.value);
      return yearB - yearA;
    });
  }, [periods]);

  const handleGroupSelect = (group) => {
    setSelectedGroup(group);
  };

  const handleBackToArchive = () => {
    setSelectedGroup(null);
  };

  const onChange_ = (value)=>{
    setActivePeriod(value)

    if(onChange){
        onChange(value);
    }
  }


  return (
    <div className="archive-groups-container">
      {/* Заголовок */}
      {false && <div className="archive-header mb-4">
        <h4>
          <FontAwesomeIcon icon={faArchive} className="me-2" />
          Архів груп за попередні роки
        </h4>
        <p className="text-muted">Оберіть навчальний рік для перегляду груп</p>
      </div>}

      {/* Табы с периодами */}
      <div className="periods-tabs mb-4">
        <ul className="nav nav-tabs">
            <li key="tab_name_" className="nav-item"><span class="queuetable-label text-white-50">навчальний рік</span></li>
          {sortedPeriods.map((period) => (
            <li key={period.value} className="nav-item">
              <button
                className={`nav-link ${activePeriod === period.value ? 'active' : ''}`}
                onClick={() => onChange_(period.value)}
              >
                <FontAwesomeIcon icon={faCalendarAlt} className="me-1" />
                {formatPeriodDisplay(period.value)}
              </button>
            </li>
          ))}
        </ul>
      </div>

      {/* Список групп для выбранного периода */}
      <div className="groups-list">        
        {children}
        {!isEmpty && (
          <div className="text-center py-5">
            <FontAwesomeIcon icon={faArchive} size="3x" className="text-muted mb-3" />
            <p className="text-muted">Немає груп для обраного періоду</p>
          </div>
        )}
      </div>

      {/* Кнопка закрытия */}
      {false && <div className="text-end mt-4">
        <button 
          className="btn btn-secondary"
          onClick={onCloseArchive}
        >
          Закрити архів
        </button>
      </div>}
    </div>
  );
};

// Пропсы по умолчанию
ArchiveGroupsTabs.defaultProps = {
  periods: [],
  groupsData: [],
  onCloseArchive: () => {}
};

export default ArchiveGroupsTabs;